document.addEventListener('DOMContentLoaded', () => {
    const lines = document.querySelector('.header__lines');
    if (lines === null) {
        return;
    }
    const header = lines.parentNode;
    const OPENED_CLASS = 'header_opened';
    let OPENED = false;
    lines.addEventListener('click', () => {
        if (OPENED) {
            header.classList.remove(OPENED_CLASS);
            OPENED = false;
            return
        }

        header.classList.add(OPENED_CLASS);
        OPENED = true;
    })
});
